import cn from "classnames";
import { forwardRef } from "react";
import { useSelectContext } from "../../context";
import { VirtualListProps } from "./types";
import styles from "./styles.module.scss";

export const VirtualList = forwardRef<HTMLDivElement, VirtualListProps>(
  ({ children, className, dataTestId, topOffset, totalHeight }, ref) => {
    const { listboxId } = useSelectContext();

    return (
      <div
        className={styles["scroll-container"]}
        ref={ref}
        data-test-id={dataTestId}
      >
        <div
          style={{
            height: totalHeight,
          }}
          className={styles["virtual-list-wrapper"]}
        >
          <ul
            id={listboxId}
            role="listbox"
            style={{
              transform: `translateY(${topOffset})`,
            }}
            className={cn(styles["virtual-list"], className)}
          >
            {children}
          </ul>
        </div>
      </div>
    );
  }
);
